import * as React from 'react';

interface SparklingSvgProps {
    width?: number;
    height?: number;
    className?: string;
    color?: string;
}

export const SparklingSvg: React.FC<SparklingSvgProps> = ({
    width = 21,
    height = 21,
    className = '',
    color = '#261B36',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            viewBox="0 0 21 21"
            fill="none"
        >
            <path
                d="M12.3013 4.35512C13.4841 4.35512 14.443 3.39622 14.443 2.21338H15.4315C15.4315 3.39622 16.3904 4.35512 17.5732 4.35512V5.34361C16.3904 5.34361 15.4315 6.3025 15.4315 7.48535H14.443C14.443 6.3025 13.4841 5.34361 12.3013 5.34361V4.35512ZM0.878662 10.1213C3.79029 10.1213 6.15063 7.76099 6.15063 4.84936H7.90795C7.90795 7.76099 10.2683 10.1213 13.1799 10.1213V11.8787C10.2683 11.8787 7.90795 14.239 7.90795 17.1506H6.15063C6.15063 14.239 3.79029 11.8787 0.878662 11.8787V10.1213ZM15.1569 12.7573C15.1569 14.3344 13.8784 15.613 12.3013 15.613V16.931C13.8784 16.931 15.1569 18.2095 15.1569 19.7866H16.4749C16.4749 18.2095 17.7534 16.931 19.3305 16.931V15.613C17.7534 15.613 16.4749 14.3344 16.4749 12.7573H15.1569Z"
                fill={color}
            />
        </svg>
    );
};
